import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FirebaseService } from './firebase.service';

export type Log = {
  id: string;
  level: string;
  message: string;
  created_at: string;
};

export type LogDetails = {
  request_id: string;
  client_ip: string;
  method: string;
  url: string;
  header: string;
  body: string;
  user_id: string;
  email: string;
  request_time: string;
  truncated_logs: boolean;
  logs: Log[];
};

@Injectable({
  providedIn: 'root',
})
export class LogService {
  private readonly searchLogsUrl = environment.serverUrl + '/logs/search';

  constructor(
    private http: HttpClient,
    private firebaseService: FirebaseService
  ) {}

  searchLogs(query: string, startDate?: string, endDate?: string) {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        const encodedQuery = encodeURIComponent(query);
        let url = `${this.searchLogsUrl}?query=${encodedQuery}`;

        if (startDate) {
          url += `&startDate=${encodeURIComponent(startDate)}`;
        }
        if (endDate) {
          url += `&endDate=${encodeURIComponent(endDate)}`;
        }

        return this.http.get<LogDetails[]>(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      })
    );
  }
}
